var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeachMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8e8e98;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #363c4f;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,26V6c0-1.38,1.12-2.5,2.5-2.5,.57,0,1.08,.18,1.5,.5V24c-.42-.32-.93-.5-1.5-.5-1.38,0-2.5,1.12-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.5 24.5 28.5 24.5 28.5 9 7 9.22 7 8.22 29.5 8 29.5 24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.5,29c-1.65,0-3-1.35-3-3V6c0-1.65,1.35-3,3-3,.66,0,1.28,.21,1.8,.6l.2,.15V25.01l-.8-.61c-.34-.26-.76-.4-1.2-.4-1.1,0-2,.9-2,2s.9,2,2,2v1Zm0-25c-1.1,0-2,.9-2,2V23.77c.77-.69,1.98-.95,3-.6V4.27c-.3-.17-.64-.27-1-.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.08,24.26c-1.46,0-2.91-.55-4.02-1.66-2.22-2.22-2.22-5.82,0-8.04s5.82-2.22,8.04,0,2.22,5.82,0,8.04c-1.11,1.11-2.56,1.66-4.02,1.66Zm0-10.36c-1.2,0-2.4,.46-3.31,1.37-1.83,1.83-1.83,4.8,0,6.62s4.8,1.83,6.62,0,1.83-4.8,0-6.62c-.91-.91-2.11-1.37-3.31-1.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.13,
    y: 21.88,
    width: 1,
    height: 2.5,
    transform: "translate(-9.73 22.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.55,
    y: 25.23,
    width: 6.62,
    height: 2.26,
    transform: "translate(26.21 -10.56) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.4,30.21l-5.39-5.39,2.31-2.31,5.39,5.39-2.31,2.31Zm-3.98-5.39l3.98,3.97,.89-.89-3.97-3.98-.89,.89Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.5,
    y: 28,
    width: 17.56,
    height: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeachMap);
export default __webpack_public_path__ + "static/media/SeachMap.68d4fe7a42e6351c1451286674956e29.svg";
export { ForwardRef as ReactComponent };